import { createApi, retry } from "@reduxjs/toolkit/query/react"
import { axiosBaseQuery } from "api/service"

const baseQuery = axiosBaseQuery()

const baseQueryWithRetry = retry(baseQuery, { maxRetries: 0 })

export enum TAGS {
  USER = "User",
  BALANCE = "Balance",
  BOSS = "BOSS",
  LOCATION = "Location",
  QUESTS = "Quests",
  TOOLS = "Tools",
  GOLD = "Gold",
  INFO_MODALS = "INFO_MODALS",
  DAILY_REWARDS = "Daily rewards",
  WITHDRAWAL = "Withdrawal",
  STAKING = "Staking",
  EXPEDITIONS = "Expeditions",
  COLLECT_COIN = "Collect coin",
  HAPPY_HOUR = "Happy hour",
  ELIXIRS = "Elixirs",
  ELIXIRS_COUNT = "Elixirs_count",
  ELIXIRS_INVENTORY = "Elixirs_inventory",
  ELIXIRS_ACTIVATED = "Elixirs_activated",
  DARK_ELIXIRS_INVENTORY = "DARK_ELIXIRS_INVENTORY",
  DARK_ELIXIRS_ACTIVATED = "DARK_ELIXIRS_ACTIVATED",
  SERVER_TIME = "Server time",
  PROFESSIONS = "Professions",
  ACHIEVEMENTS = "Achievements",
  PERSONAL_DAILY_DEALS = "PERSONAL_DAILY_DEALS",
  PREFORMS = "PREFORMS",
  STORE = "STORE",
  TOOL_TEMPLATES = "TOOL_TEMPLATES",
  RUNES = "RUNES",
  RECIPES = "RECIPES",
  APPARELS = "APPARELS",
  SPECIAL_DEALS = "SPECIAL_DEALS",
  NY_GIFT = "NY_GIFT",
  RUNES_DROP_SHEET = "RUNES_DROP_SHEET",
  MINE_GAME = "MINE_GAME",
  MINE_CHAT = "MINE_CHAT",
  MINE_SUPPORTERS = "MINE_SUPPORTERS",
  SEASON_LEADERBOARD = "SEASON_LEADERBOARD",
  UPGRADES = "UPGRADES",
  CLANS = "CLANS",
  CLAN_CHAT = "CLAN_CHAT",
  CLAN_ANNOUNCEMENTS = "CLAN_ANNOUNCEMENTS",
  CLAN_ALTAR = "CLAN_ALTAR",
  DARK_CLAN_ALTAR = "DARK_CLAN_ALTAR",
  VIP_PASS = "VIP_PASS",
  AUCTION = "AUCTION",
  JAIL = "JAIL",
  DEPOSIT = "DEPOSIT",
  FAVORITE_ITEMS = "FAVORITE_ITEMS",
  EVENTS = "EVENTS",
  BETA_WHITELIST = "BETA_WHITELIST",
  BOSS_CLANS = "BOSS_CLANS",
  BOSS_LEADERBOARD = "BOSS_LEADERBOARD",
  CURRENCY = "CURRENCY",
  MISSIONS = "MISSIONS",
  CLAN_MISSIONS = "CLAN_MISSIONS",
  POINTS_LEADERBOARD = "POINTS_LEADERBOARD",
  SALE_CHEST = "SALE_CHEST",
  OPENABLE_MISSION_CHEST = "OPENABLE_MISSION_CHEST",
  OPENABLE_MISSION_CHEST_INSTANCES = "OPENABLE_MISSION_CHEST_INSTANCES",
  OPENABLE_MISSION_CHEST_LEADERBOARD = "OPENABLE_MISSION_CHEST_LEADERBOARD",
  BOSS_ARENA_CYCLE_LB = "BOSS_ARENA_CYCLE_LB",
  BOSS_ARENA_CYCLE_REWARDS = "BOSS_ARENA_CYCLE_REWARDS",
  BOSS_ARENA_CYCLE_STATE = "BOSS_ARENA_CYCLE_STATE",
  BOSS_ARENA_CYCLE_PENDING = "BOSS_ARENA_CYCLE_PENDING",
  HOME_BACKGROUNDS = "HOME_BACKGROUNDS"
}

export const api = createApi({
  reducerPath: "splitApi",
  baseQuery: baseQueryWithRetry,
  refetchOnFocus: false,
  endpoints: () => ({})
})
